import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import jsPDF from 'jspdf';
import { FaArrowLeft, FaTrash, FaPlus, FaGasPump, FaTachometerAlt, FaCar, FaCheckCircle, FaTimesCircle, FaMoneyBillWave, FaUser, FaCalendarAlt, FaExclamationTriangle } from 'react-icons/fa';

// IMPORTAR LA IMAGEN DESDE ASSETS
import vistaSuperilorImg from '../../assets/vista-superior.jpg';


export default function Recepcion({ goBack }) {
    const [alquileresActivos, setAlquileresActivos] = useState([]);
    const [selected, setSelected] = useState(null);
    const [imageError, setImageError] = useState(false);
    
    const [form, setForm] = useState({
        km_retorno: '', gasolina: 'Full', limpio: true,
        metodo_pago: 'efectivo', devolver_garantia: true
    });

    const [cargosExtras, setCargosExtras] = useState([]); 
    const [puntosDaños, setPuntosDaños] = useState([]); 

    useEffect(() => { fetchActivos(); }, []);

    useEffect(() => {
        setImageError(false);
    }, [selected]);

    const fetchActivos = async () => {
        try {
            const res = await axios.get('https://api.alquilacarbolivia.com/api/vehiculos');
            const ocupados = res.data.filter(v => v.estado === 'ocupado');
            const completos = [];
            for(let car of ocupados) {
                const det = await axios.get(`https://api.alquilacarbolivia.com/api/vehiculos/${car.id}`);
                if(det.data.rentas[0]) completos.push({ car, renta: det.data.rentas[0] });
            }
            setAlquileresActivos(completos);
        } catch (error) { console.error(error); }
    };

    const agregarCargo = () => setCargosExtras([...cargosExtras, { desc: '', monto: 0 }]);
    const eliminarCargo = (index) => setCargosExtras(cargosExtras.filter((_, i) => i !== index));
    const updateCargo = (index, field, value) => {
        const nuevos = [...cargosExtras];
        nuevos[index][field] = value;
        setCargosExtras(nuevos);
    };

    const calcularTotales = () => {
        if (!selected) return { montoContrato: 0, totalExtras: 0, totalFinal: 0, garantia: 0 };
        const montoContrato = parseFloat(selected.renta.total) || 0;
        const garantia = parseFloat(selected.renta.garantia) || 0;
        const totalExtras = cargosExtras.reduce((acc, c) => acc + (parseFloat(c.monto) || 0), 0);
        return { montoContrato, totalExtras, totalFinal: montoContrato + totalExtras, garantia };
    };

    const calcularKmRecorridos = () => {
        if (!selected || !form.km_retorno) return 0;
        const kmSalida = parseFloat(selected.renta.km_salida) || 0;
        const kmRetorno = parseFloat(form.km_retorno) || 0;
        return Math.max(0, kmRetorno - kmSalida);
    };

    // Función para obtener la URL de la imagen correcta
    const getImageUrl = () => {
        // Primero intentar con la imagen del vehículo desde el backend
        if (selected?.car?.imagen) {
            if (selected.car.imagen.startsWith('http://') || selected.car.imagen.startsWith('https://')) {
                return selected.car.imagen;
            }
            if (selected.car.imagen.startsWith('/')) {
                return `https://api.alquilacarbolivia.com${selected.car.imagen}`;
            }
            return `https://api.alquilacarbolivia.com/uploads/vehiculos/${selected.car.imagen}`;
        }
        
        // Si no hay imagen específica, usar la imagen genérica importada
        return vistaSuperilorImg;
    };

    const handleMapaClick = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 200;
        const y = ((e.clientY - rect.top) / rect.height) * 400;
        setPuntosDaños([...puntosDaños, { x, y }]);
    };

    const handleFinalizar = async (e) => {
        e.preventDefault();
        const { totalFinal } = calcularTotales();
        try {
            await axios.post('https://api.alquilacarbolivia.com/api/operaciones/devolver', {
                vehiculo_id: selected.car.id,
                alquiler_id: selected.renta.id,
                km_retorno: form.km_retorno,
                gasolina_retorno: form.gasolina,
                limpio: form.limpio,
                monto_final_pagado: totalFinal,
                metodo_pago_recepcion: form.metodo_pago,
                garantia_devuelta: form.devolver_garantia,
                daños: JSON.stringify(cargosExtras),
                mapa_daños: JSON.stringify(puntosDaños)
            });
            generarPDFRecepcion(totalFinal);
            Swal.fire({
                title: '¡Recepción Completada!',
                html: '<p class="mb-2">El vehículo ha sido recibido exitosamente.</p><p class="text-success fw-bold">✓ Acta de recepción generada</p>',
                icon: 'success',
                confirmButtonColor: '#dc3545'
            });
            goBack();
        } catch (error) { 
            Swal.fire('Error', 'No se pudo procesar la recepción', 'error'); 
        }
    };

    const generarPDFRecepcion = (totalFinal) => {
        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;
        const { montoContrato, totalExtras, garantia } = calcularTotales();
        
        doc.setFillColor(220, 53, 69);
        doc.rect(0, 0, pageWidth, 45, 'F');
        
        doc.setFillColor(255, 255, 255);
        doc.circle(30, 22, 12, 'F');
        doc.setFillColor(220, 53, 69);
        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text('AC', 30, 25, { align: 'center' });
        
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(24);
        doc.text('ALQUILACAR S.R.L.', 50, 20);
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text('Acta de Recepción y Liquidación Final', 50, 28);
        
        doc.setFillColor(255, 193, 7);
        doc.roundedRect(pageWidth - 55, 10, 45, 12, 2, 2, 'F');
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        const docNum = Date.now().toString().slice(-8);
        doc.text(`N° ${docNum}`, pageWidth - 32.5, 18, { align: 'center' });
        
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.text(`Fecha: ${new Date().toLocaleDateString('es-ES')}`, pageWidth - 32.5, 30, { align: 'center' });
        
        doc.setTextColor(220, 53, 69);
        doc.setFontSize(18);
        doc.setFont("helvetica", "bold");
        doc.text('ACTA DE RECEPCIÓN DE VEHÍCULO', pageWidth / 2, 60, { align: 'center' });
        
        let yPos = 75;
        doc.setDrawColor(220, 53, 69);
        doc.setLineWidth(0.5);
        doc.roundedRect(15, yPos, pageWidth - 30, 40, 3, 3);
        
        doc.setFillColor(220, 53, 69);
        doc.rect(15, yPos, pageWidth - 30, 8, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text('I. INFORMACIÓN DEL VEHÍCULO Y CLIENTE', 20, yPos + 5.5);
        
        yPos += 15;
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text('VEHÍCULO:', 20, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(`${selected.car.marca} ${selected.car.modelo} - Placa: ${selected.car.placa}`, 50, yPos);
        
        yPos += 7;
        doc.setFont("helvetica", "bold");
        doc.text('CLIENTE:', 20, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(selected.renta.cliente.toUpperCase(), 50, yPos);
        
        yPos += 7;
        doc.setFont("helvetica", "bold");
        doc.text('PERÍODO:', 20, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(`${selected.renta.fecha_inicio} al ${selected.renta.fecha_fin}`, 50, yPos);
        
        yPos += 15;
        doc.setDrawColor(220, 53, 69);
        doc.roundedRect(15, yPos, pageWidth - 30, 45, 3, 3);
        
        doc.setFillColor(220, 53, 69);
        doc.rect(15, yPos, pageWidth - 30, 8, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text('II. COMPARATIVA DE ESTADO', 20, yPos + 5.5);
        
        yPos += 15;
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        
        doc.setFont("helvetica", "bold");
        doc.text('CONCEPTO', 20, yPos);
        doc.text('ENTREGA', 90, yPos);
        doc.text('RETORNO', 145, yPos);
        
        yPos += 8;
        doc.setFont("helvetica", "normal");
        doc.text('Kilometraje:', 20, yPos);
        doc.text(`${selected.renta.km_salida} KM`, 90, yPos);
        doc.text(`${form.km_retorno} KM`, 145, yPos);
        
        yPos += 7;
        doc.text('Combustible:', 20, yPos);
        doc.text(selected.renta.gasolina_salida || 'Full', 90, yPos);
        doc.text(form.gasolina, 145, yPos);
        
        yPos += 7;
        doc.text('Estado Limpieza:', 20, yPos);
        doc.text('Limpio', 90, yPos);
        doc.text(form.limpio ? 'Limpio' : 'Sucio', 145, yPos);
        
        yPos += 7;
        doc.setFont("helvetica", "bold");
        doc.setFillColor(240, 248, 255);
        doc.roundedRect(18, yPos - 3, pageWidth - 36, 8, 2, 2, 'F');
        doc.text(`Kilómetros recorridos: ${calcularKmRecorridos()} KM`, 22, yPos + 2);
        
        yPos += 18;
        if (cargosExtras.length > 0 || puntosDaños.length > 0) {
            doc.setDrawColor(220, 53, 69);
            doc.roundedRect(15, yPos, pageWidth - 30, 10 + (cargosExtras.length * 7), 3, 3);
            
            doc.setFillColor(220, 53, 69);
            doc.rect(15, yPos, pageWidth - 30, 8, 'F');
            doc.setTextColor(255, 255, 255);
            doc.setFontSize(11);
            doc.setFont("helvetica", "bold");
            doc.text('III. DAÑOS Y CARGOS ADICIONALES', 20, yPos + 5.5);
            
            yPos += 15;
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(9);
            doc.setFont("helvetica", "normal");
            
            if (puntosDaños.length > 0) {
                doc.text(`- Se detectaron ${puntosDaños.length} punto(s) de daño en la inspección visual`, 20, yPos);
                yPos += 6;
            }
            
            cargosExtras.forEach((c, idx) => {
                doc.text(`${idx + 1}. ${c.desc || 'Cargo Extra'}: Bs. ${parseFloat(c.monto).toFixed(2)}`, 20, yPos);
                yPos += 6;
            });
        }
        
        yPos += 10;
        doc.setDrawColor(220, 53, 69);
        doc.roundedRect(15, yPos, pageWidth - 30, 55, 3, 3);
        
        doc.setFillColor(220, 53, 69);
        doc.rect(15, yPos, pageWidth - 30, 8, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text('IV. LIQUIDACIÓN ECONÓMICA', 20, yPos + 5.5);
        
        yPos += 15;
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        
        doc.text('Subtotal Contrato:', 20, yPos);
        doc.text(`Bs. ${montoContrato.toFixed(2)}`, pageWidth - 50, yPos, { align: 'right' });
        
        yPos += 7;
        doc.text('Cargos Adicionales:', 20, yPos);
        doc.setTextColor(220, 53, 69);
        doc.text(`+ Bs. ${totalExtras.toFixed(2)}`, pageWidth - 50, yPos, { align: 'right' });
        
        yPos += 7;
        doc.setTextColor(0, 0, 0);
        doc.text('Garantía:', 20, yPos);
        doc.text(`Bs. ${garantia.toFixed(2)}`, pageWidth - 50, yPos, { align: 'right' });
        
        yPos += 7;
        doc.text('Estado Garantía:', 20, yPos);
        doc.text(form.devolver_garantia ? 'Devuelta' : 'Retenida', pageWidth - 50, yPos, { align: 'right' });
        
        yPos += 7;
        doc.text('Método de Pago:', 20, yPos);
        doc.text(form.metodo_pago.toUpperCase(), pageWidth - 50, yPos, { align: 'right' });
        
        yPos += 12;
        doc.setFillColor(255, 193, 7);
        doc.roundedRect(18, yPos - 5, pageWidth - 36, 12, 2, 2, 'F');
        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 0, 0);
        doc.text(`TOTAL PAGADO: Bs. ${totalFinal.toFixed(2)}`, pageWidth / 2, yPos + 2, { align: 'center' });
        
        yPos += 18;
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(0, 0, 0);
        const declaracion = 'El cliente declara haber devuelto el vehículo y realizado el pago correspondiente. Ambas partes acuerdan que el contrato de alquiler ha finalizado satisfactoriamente.';
        const lines = doc.splitTextToSize(declaracion, pageWidth - 30);
        doc.text(lines, 15, yPos);
        
        doc.setFontSize(7);
        doc.setTextColor(128, 128, 128);
        doc.text('Documento generado automáticamente por el Sistema ALQUILACAR', pageWidth / 2, pageHeight - 10, { align: 'center' });
        
        doc.save(`Recepcion_${selected.car.placa}_${docNum}.pdf`);
    };

    return (
        <div className="min-vh-100" style={{ background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)' }}>
            <div className="shadow-lg" style={{ 
                background: 'linear-gradient(135deg, #dc3545 0%, #ff6b6b 100%)',
                padding: '1.5rem'
            }}>
                <div className="container-fluid">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-3">
                            <button 
                                className="btn btn-light shadow-sm hover-lift" 
                                onClick={goBack}
                                style={{ borderRadius: '10px', fontWeight: '600' }}
                            >
                                <FaArrowLeft className="me-2" />
                                Volver al Menú
                            </button>
                            <div className="text-white">
                                <h3 className="mb-0 fw-bold d-flex align-items-center gap-2">
                                    <FaCheckCircle />
                                    RECEPCIÓN DE VEHÍCULO
                                </h3>
                                <small style={{ opacity: 0.9 }}>Check-out y liquidación final</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid p-4">
                {!selected ? (
                    <div>
                        <div className="mb-4">
                            <h4 className="fw-bold text-dark mb-1">Alquileres Activos</h4>
                            <p className="text-muted">Seleccione el vehículo que será devuelto</p>
                        </div>
                        
                        <div className="row g-4">
                            {alquileresActivos.map(item => (
                                <div key={item.car.id} className="col-lg-4 col-md-6">
                                    <div 
                                        className="card h-100 border-0 shadow-sm"
                                        onClick={() => setSelected(item)}
                                        style={{
                                            cursor: 'pointer',
                                            borderRadius: '15px',
                                            transition: 'all 0.3s ease',
                                            borderLeft: '5px solid #dc3545'
                                        }}
                                        onMouseEnter={e => {
                                            e.currentTarget.style.transform = 'translateY(-5px)';
                                            e.currentTarget.style.boxShadow = '0 10px 30px rgba(220,53,69,0.3)';
                                        }}
                                        onMouseLeave={e => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '';
                                        }}
                                    >
                                        <div className="card-body p-4">
                                            <div className="d-flex justify-content-between align-items-start mb-3">
                                                <div>
                                                    <h5 className="fw-bold mb-1">
                                                        <FaCar className="me-2 text-danger" />
                                                        {item.car.marca} {item.car.modelo}
                                                    </h5>
                                                    <span className="badge bg-danger">{item.car.placa}</span>
                                                </div>
                                                <div className="bg-danger bg-opacity-10 p-2 rounded-circle">
                                                    <FaCheckCircle className="text-danger" style={{ fontSize: '1.5rem' }} />
                                                </div>
                                            </div>
                                            
                                            <div className="border-top pt-3 mt-3">
                                                <p className="mb-2 small">
                                                    <FaUser className="me-2 text-muted" />
                                                    <strong>Cliente:</strong> {item.renta.cliente}
                                                </p>
                                                <p className="mb-2 small">
                                                    <FaCalendarAlt className="me-2 text-muted" />
                                                    <strong>Desde:</strong> {item.renta.fecha_inicio}
                                                </p>
                                                <p className="mb-0 small">
                                                    <FaTachometerAlt className="me-2 text-muted" />
                                                    <strong>KM Salida:</strong> {item.renta.km_salida} KM
                                                </p>
                                            </div>
                                            
                                            <button className="btn btn-danger w-100 mt-3 fw-bold">
                                                Procesar Recepción →
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            
                            {alquileresActivos.length === 0 && (
                                <div className="col-12">
                                    <div className="card border-0 shadow-sm" style={{ borderRadius: '15px' }}>
                                        <div className="card-body text-center py-5">
                                            <FaCar style={{ fontSize: '4rem', color: '#ddd', marginBottom: '1rem' }} />
                                            <h5 className="text-muted">No hay alquileres activos</h5>
                                            <p className="text-muted small">Todos los vehículos están disponibles.</p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <form onSubmit={handleFinalizar}>
                        <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                            <div style={{
                                background: 'linear-gradient(135deg, #dc3545 0%, #ff6b6b 100%)',
                                padding: '1.5rem',
                                color: 'white'
                            }}>
                                <div className="row align-items-center">
                                    <div className="col-md-8">
                                        <h4 className="fw-bold mb-2">
                                            <FaCar className="me-2" />
                                            {selected.car.marca} {selected.car.modelo}
                                        </h4>
                                        <div className="d-flex gap-4 flex-wrap">
                                            <span><strong>Placa:</strong> {selected.car.placa}</span>
                                            <span><strong>Cliente:</strong> {selected.renta.cliente}</span>
                                            <span><strong>Inicio:</strong> {selected.renta.fecha_inicio}</span>
                                        </div>
                                    </div>
                                    <div className="col-md-4 text-md-end mt-3 mt-md-0">
                                        <div className="badge bg-warning text-dark px-3 py-2" style={{ fontSize: '1rem' }}>
                                            <FaMoneyBillWave className="me-1" />
                                            Contrato: Bs. {parseFloat(selected.renta.total).toFixed(2)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row g-4">
                            <div className="col-lg-6">
                                <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: '15px' }}>
                                    <div className="card-header bg-white border-0 pt-4 px-4">
                                        <h5 className="fw-bold d-flex align-items-center gap-2 text-danger mb-0">
                                            <div style={{
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '50%',
                                                background: 'linear-gradient(135deg, #dc3545 0%, #ff6b6b 100%)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: 'white'
                                            }}>
                                                <FaExclamationTriangle />
                                            </div>
                                            Inspección Visual de Daños
                                        </h5>
                                        <p className="text-muted small mb-0 mt-2">Haga clic en el vehículo para marcar puntos de daño</p>
                                    </div>
                                    <div className="card-body text-center" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
                                        <div 
                                            style={{ 
                                                position: 'relative', 
                                                maxWidth: '100%', 
                                                margin: '0 auto',
                                                cursor: 'crosshair'
                                            }}
                                            onClick={handleMapaClick}
                                        >
                                            <img 
                                                src={getImageUrl()}
                                                alt={`Vista superior ${selected.car.marca} ${selected.car.modelo}`}
                                                onError={() => setImageError(true)}
                                                style={{
                                                    width: '100%',
                                                    display: 'block',
                                                    border: '2px solid #dee2e6',
                                                    borderRadius: '10px',
                                                    background: 'white'
                                                }}
                                            />
                                            
                                            {/* Marcadores de daño sobre la imagen */}
                                            {puntosDaños.map((p, i) => (
                                                <div
                                                    key={i}
                                                    style={{
                                                        position: 'absolute',
                                                        left: `${(p.x / 200) * 100}%`,
                                                        top: `${(p.y / 400) * 100}%`,
                                                        transform: 'translate(-50%, -50%)',
                                                        width: '32px',
                                                        height: '32px',
                                                        borderRadius: '50%',
                                                        backgroundColor: '#dc3545',
                                                        border: '3px solid white',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        color: 'white',
                                                        fontWeight: 'bold',
                                                        fontSize: '14px',
                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                                                        pointerEvents: 'none',
                                                        zIndex: 10
                                                    }}
                                                >
                                                    {i + 1}
                                                </div>
                                            ))}
                                        </div>
                                        
                                        <div className="mt-3 d-flex gap-2 justify-content-center flex-wrap">
                                            <span className="badge bg-danger">{puntosDaños.length} punto(s) marcado(s)</span>
                                            {puntosDaños.length > 0 && (
                                                <button 
                                                    type="button" 
                                                    className="btn btn-sm btn-outline-danger"
                                                    onClick={() => setPuntosDaños([])}
                                                >
                                                    <FaTrash className="me-1" /> Limpiar Marcas
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="card border-0 shadow-sm" style={{ borderRadius: '15px' }}>
                                    <div className="card-header bg-white border-0 pt-4 px-4">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h5 className="fw-bold d-flex align-items-center gap-2 text-warning mb-0">
                                                <div style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '50%',
                                                    background: 'linear-gradient(135deg, #ffc107 0%, #ff6f00 100%)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    color: 'white'
                                                }}>
                                                    <FaMoneyBillWave />
                                                </div>
                                                Cargos Adicionales
                                            </h5>
                                            <button 
                                                type="button" 
                                                className="btn btn-sm btn-warning fw-bold shadow-sm"
                                                onClick={agregarCargo}
                                                style={{ borderRadius: '10px' }}
                                            >
                                                <FaPlus className="me-1" /> Añadir Cargo
                                            </button>
                                        </div>
                                    </div>
                                    <div className="card-body p-4">
                                        {cargosExtras.length === 0 ? (
                                            <div className="text-center py-4 text-muted">
                                                <FaCheckCircle style={{ fontSize: '2rem', marginBottom: '0.5rem' }} />
                                                <p className="mb-0 small">No hay cargos adicionales</p>
                                            </div>
                                        ) : (
                                            <div className="space-y-3">
                                                {cargosExtras.map((c, i) => (
                                                    <div key={i} className="row g-2 mb-3 p-3 rounded" style={{ background: '#f8f9fa' }}>
                                                        <div className="col-7">
                                                            <label className="form-label small fw-semibold mb-1">Concepto</label>
                                                            <input 
                                                                className="form-control" 
                                                                placeholder="Ej: Multa por exceso de velocidad" 
                                                                value={c.desc} 
                                                                onChange={e => updateCargo(i, 'desc', e.target.value)}
                                                                style={{ borderRadius: '8px' }}
                                                            />
                                                        </div>
                                                        <div className="col-3">
                                                            <label className="form-label small fw-semibold mb-1">Monto (Bs)</label>
                                                            <input 
                                                                type="number" 
                                                                className="form-control" 
                                                                placeholder="0.00" 
                                                                value={c.monto} 
                                                                onChange={e => updateCargo(i, 'monto', e.target.value)}
                                                                style={{ borderRadius: '8px' }}
                                                            />
                                                        </div>
                                                        <div className="col-2 d-flex align-items-end">
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-danger w-100"
                                                                onClick={() => eliminarCargo(i)}
                                                                style={{ borderRadius: '8px' }}
                                                            >
                                                                <FaTrash />
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: '15px' }}>
                                    <div className="card-header bg-white border-0 pt-4 px-4">
                                        <h5 className="fw-bold d-flex align-items-center gap-2 text-primary mb-0">
                                            <div style={{
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '50%',
                                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: 'white'
                                            }}>
                                                <FaTachometerAlt />
                                            </div>
                                            Estado de Retorno
                                        </h5>
                                    </div>
                                    <div className="card-body p-4">
                                        <div className="row g-3 mb-3">
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <FaTachometerAlt className="me-2 text-primary" />
                                                    Kilometraje de Retorno *
                                                </label>
                                                <input 
                                                    type="number" 
                                                    className="form-control form-control-lg" 
                                                    required 
                                                    value={form.km_retorno}
                                                    style={{ borderRadius: '10px' }}
                                                    onChange={e => setForm({...form, km_retorno: e.target.value})}
                                                />
                                                <small className="text-muted">
                                                    <FaCheckCircle className="me-1 text-success" />
                                                    KM Salida: {selected.renta.km_salida}
                                                </small>
                                                {form.km_retorno && (
                                                    <div className="mt-2">
                                                        <span className="badge bg-info">
                                                            Recorridos: {calcularKmRecorridos()} KM
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <FaGasPump className="me-2 text-primary" />
                                                    Nivel de Combustible *
                                                </label>
                                                <select 
                                                    className="form-select form-select-lg" 
                                                    value={form.gasolina}
                                                    style={{ borderRadius: '10px' }}
                                                    onChange={e => setForm({...form, gasolina: e.target.value})}
                                                >
                                                    <option value="Full">🟢 Tanque Lleno (Full)</option>
                                                    <option value="3/4">🟡 3/4 Tanque</option>
                                                    <option value="1/2">🟠 1/2 Tanque</option>
                                                    <option value="1/4">🟠 1/4 Tanque</option>
                                                    <option value="Reserva">🔴 Reserva</option>
                                                </select>
                                                <small className="text-muted">
                                                    Salida: {selected.renta.gasolina_salida || 'Full'}
                                                </small>
                                            </div>
                                        </div>

                                        <div 
                                            className="p-3 rounded mb-3" 
                                            style={{ 
                                                background: form.limpio ? 'linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)' : 'linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%)',
                                                border: `2px solid ${form.limpio ? '#28a745' : '#dc3545'}`
                                            }}
                                        >
                                            <div className="form-check form-switch">
                                                <input 
                                                    className="form-check-input" 
                                                    type="checkbox" 
                                                    id="limpioSwitch"
                                                    checked={form.limpio} 
                                                    onChange={e => setForm({...form, limpio: e.target.checked})}
                                                    style={{ width: '3rem', height: '1.5rem' }}
                                                />
                                                <label className="form-check-label fw-bold" htmlFor="limpioSwitch">
                                                    {form.limpio ? (
                                                        <><FaCheckCircle className="me-2 text-success" /> Vehículo Limpio</>
                                                    ) : (
                                                        <><FaTimesCircle className="me-2 text-danger" /> Vehículo Sucio</>
                                                    )}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card border-0 shadow-lg mb-4" style={{ borderRadius: '15px' }}>
                                    <div className="card-header bg-white border-0 pt-4 px-4">
                                        <h5 className="fw-bold d-flex align-items-center gap-2 text-success mb-0">
                                            <div style={{
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '50%',
                                                background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: 'white'
                                            }}>
                                                <FaMoneyBillWave />
                                            </div>
                                            Liquidación Final
                                        </h5>
                                    </div>
                                    <div className="card-body p-4">
                                        <div className="p-3 rounded mb-3" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="text-muted">Subtotal Contrato:</span>
                                                <strong>Bs. {calcularTotales().montoContrato.toFixed(2)}</strong>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="text-danger">Cargos Adicionales:</span>
                                                <strong className="text-danger">+ Bs. {calcularTotales().totalExtras.toFixed(2)}</strong>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2 pb-2 border-bottom">
                                                <span className="text-muted">Garantía Depositada:</span>
                                                <strong>Bs. {calcularTotales().garantia.toFixed(2)}</strong>
                                            </div>
                                            <div className="text-center mt-3">
                                                <p className="mb-1 small text-muted">TOTAL A COBRAR</p>
                                                <h2 className="fw-bold mb-0" style={{
                                                    fontSize: '2.5rem',
                                                    background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                                    WebkitBackgroundClip: 'text',
                                                    WebkitTextFillColor: 'transparent',
                                                    backgroundClip: 'text'
                                                }}>
                                                    Bs. {calcularTotales().totalFinal.toFixed(2)}
                                                </h2>
                                            </div>
                                        </div>

                                        <div className="p-3 rounded mb-3" style={{ background: '#2d3748', color: 'white' }}>
                                            <div className="form-check form-switch mb-3">
                                                <input 
                                                    className="form-check-input" 
                                                    type="checkbox" 
                                                    id="garantiaSwitch"
                                                    checked={form.devolver_garantia} 
                                                    onChange={e => setForm({...form, devolver_garantia: e.target.checked})}
                                                    style={{ width: '3rem', height: '1.5rem' }}
                                                />
                                                <label className="form-check-label fw-bold" htmlFor="garantiaSwitch">
                                                    {form.devolver_garantia ? '✓ Devolver Garantía' : '✗ Retener Garantía'}
                                                </label>
                                            </div>
                                            
                                            <label className="form-label fw-semibold mb-2">Método de Pago</label>
                                            <select 
                                                className="form-select form-select-lg"
                                                style={{ borderRadius: '10px' }}
                                                onChange={e => setForm({...form, metodo_pago: e.target.value})}
                                            >
                                                <option value="efectivo">💵 Efectivo</option>
                                                <option value="qr">📱 QR / Transferencia</option>
                                                <option value="tarjeta">💳 Tarjeta</option>
                                            </select>
                                        </div>

                                        <button 
                                            type="submit" 
                                            className="btn btn-lg w-100 text-white fw-bold shadow-lg"
                                            style={{
                                                borderRadius: '15px',
                                                padding: '1rem',
                                                fontSize: '1.2rem',
                                                background: 'linear-gradient(135deg, #dc3545 0%, #ff6b6b 100%)',
                                                border: 'none',
                                                transition: 'all 0.3s ease'
                                            }}
                                            onMouseEnter={e => e.target.style.transform = 'scale(1.02)'}
                                            onMouseLeave={e => e.target.style.transform = 'scale(1)'}
                                        >
                                            <FaCheckCircle className="me-2" />
                                            FINALIZAR RECEPCIÓN Y GENERAR ACTA
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                )}
            </div>

            <style>{`
                .hover-lift {
                    transition: all 0.3s ease;
                }
                .hover-lift:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                }
            `}</style>
        </div>
    );
}